import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {withTranslation} from 'react-i18next'

import {dataService} from 'services'
import requestHandler from 'utils/requestHandler'
import BButton from 'components/Form/Fields/BButton'
import LandingCarousel from 'components/Landing/LandingCarousel'
import ProductsSlider from 'components/Landing/ProductsSlider'
import LandingLinks from 'components/Landing/LandingLinks'
import LandingBlog from 'components/Landing/LandingBlog'

const Landing = ({t}) => {
  const [data, setData] = useState({loading: true})

  useEffect(() => {
    setData({loading: true})
    requestHandler(() => dataService.getWebAppConfig(), 'json')
      .then(r => {
        if (r.success) {
          setData(r.data)
        } else {
          setData({error: true})
        }
      })
  }, [])

  return (
    data && !data?.loading && !data?.error ? (
      <div id='land'>
        <LandingCarousel data={data.carousel}/>

        <ProductsSlider
          Title={<h1>{t('Products available')}<br/><b>{t('in under 90 minutes')}</b></h1>}
          Button={<Link to='/'><BButton>{t('SEE MORE')} <b>{t('‘90 MINUTE’ PRODUCTS')}</b></BButton></Link>}
          data={data.top90minProducts}
        />
        <div id='land-hotDeals'>
          <ProductsSlider
            Title={<h1>{t('Hot new products')}</h1>}
            Button={<Link to='/'><BButton>{t('SEE MORE')} <b>{t('HOT PRODUCTS')}</b></BButton></Link>}
            data={data.hotDealsProducts}
          />
        </div>

        <LandingLinks className='land-topMerch' H1={<h1><b>{t('Our trusted suppliers')}</b></h1>} links={data.topMerchants}/>
        <LandingLinks className='land-sayAboutUs' H1={<h1><b>{t('Media coverage')}</b></h1>} links={data.wroteAboutUs}/>

        <LandingBlog t={t}/>
      </div>
    ) : data?.loading ? (
      'loading...'
    ) : (
      'error'
    )
  )
}

export default (withTranslation()(Landing))
